import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SegmentedControl.css';
import cx from 'classnames';

/**
 * SegmentedControl - Modern toggle button group for single selection
 * Replaces traditional dropdown/select for 2-4 options
 */
class SegmentedControl extends React.Component {
    static propTypes = {
        options: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.node, // React component or string
        })).isRequired,
        value: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        name: PropTypes.string,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        disabled: false,
    };

    handleClick = (optionValue) => {
        const { onChange, input } = this.props;
        if (input && input.onChange) {
            input.onChange(optionValue);
        } else if (onChange) {
            onChange(optionValue);
        }
    };

    render() {
        const { options, input, disabled } = this.props;
        const currentValue = input ? input.value : this.props.value;

        return (
            <div className={s.segmentedControl}>
                {options.map((option, index) => (
                    <button
                        key={option.value}
                        type="button"
                        className={cx(
                            s.segment,
                            currentValue === option.value && s.segmentActive,
                            disabled && s.segmentDisabled
                        )}
                        onClick={() => !disabled && this.handleClick(option.value)}
                        disabled={disabled}
                    >
                        {option.icon && <span className={s.segmentIcon}>{option.icon}</span>}
                        <span className={s.segmentLabel}>{option.label}</span>
                    </button>
                ))}
            </div>
        );
    }
}

export default withStyles(s)(SegmentedControl);
